import gcashQRHavoc from '../assets/images/gcashQRhavoc.png'
import gcashQRStrife from '../assets/images/gcashQRstrife.png'

export const PAYMENT_RECIPIENTS = {

     STRIFE: {
    gcash: {
      title: 'GCASH',
      recipients: [
        {
          name: 'JH****L M.',
          number: '0910-156-2264'
        },
        {
          name: 'HE*****A L.',
          number: '0976-220-4009'
        },
        {
          name: 'NI***E L.',
          number: '0976-128-1087'
        }
      ],
      qrImage: gcashQRStrife 
    },
     maya: {
      title: 'MAYA',
       name: 'JHENELL M.',
        number: '0910-156-2264'
    },

    paypal: {
      title: 'PAYPAL',
      email: 'menesesjhenell@gmail.com'
    }
  },


  HAVOC: {
    gcash: {
      title: 'GCASH',
      recipients: [
        {
          name: 'CARMENCITA GARCIA',
          number: '0960-816-0501'
        }
      ],
      qrImage: gcashQRHavoc
    },
      maya: {
      title: 'MAYA (UNAVAILABLE)',
       name: '(UNAVAILABLE)',
        number: '(UNAVAILABLE)'
    },

    paypal: {
      title: 'PAYPAL',
      email: 'havoc.ranonlinephofficial@gmail.com'
    }
  },

  rules: {
    rate: '1 PHP = 1 E-POINT',
    minAmount: 100,
    disclaimer:
      'TOPUP ARE PURELY VOLUNTARY, NON-COMPULSORY, NON-TRANSFERABLE AND NON-REFUNDABLE.'
  }
}
